export const Data = [
    {
        service: 'Fast Service',
        explain: "We appreciate the customer's time and effort, and we focus on the ideas and the best solution rather than making it more complicated for the client. We aspire to exceed their expectations and provide quality service."
    },

    {
        service: 'Responsive Design',
        explain: 'The solutions that we are providing in creating websites are incredibly user-friendly and can be available when viewed in phone, laptop, tablet, or computers.'
    },

    {
        service: 'Modern Ideas',
        explain: 'We focused more on adapting to world changes and modifying the business to fit in the business world where we are bringing the most up-to-date designs to draw the attention of the clients.'
    },

    {
        service: 'Affordable',
        explain: 'Aside from providing the best solution, we also adjust our services costs to make them more reasonable to our clients and to avoid compromising their ideas and falling behind the innovations.'
    }
]